import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const ServiceImgText = ({ blok }) => (
  <div className="wrap">
  <div
    className="serviceimagetext-wrap flex justify-between inner-wrap"
    {...storyblokEditable(blok)}
  >
    <div className="serviceimagetext-content">
      <h2 className="text-2xl">{blok.subheadlineleft}</h2>
      {blok.link1 && (
        <div className="serviceimagetext-imagewrap">
        <Link href={blok.link1} >
          <img src={blok.imageleft.filename} alt={blok.imageleft.alt} />
        </Link>
        </div>
      )}
      {blok.link1newtab && (
        <div className="serviceimagetext-imagewrap">
        <Link target="_blank" href={blok.link1newtab} >
            <img
              src={blok.imageleftnewtab.filename}
              alt={blok.imageleftnewtab.alt}
            />
        </Link>
        </div>
      )}
      <p className="">{blok.textleft}</p>
    </div>
    <div className="serviceimagetext-content ml-16">
      <h2 className="text-2xl">{blok.subheadlineright}</h2>
      {blok.link2 && (
        <div className="serviceimagetext-imagewrap">
        <Link href={blok.link2} >
          <img src={blok.imageright.filename} alt={blok.imageright.alt} />
        </Link>
        </div>
      )}
      {blok.link2newtab && (
        <div className="serviceimagetext-imagewrap">
        <Link target="_blank" href={blok.link2newtab} >
            <img
              src={blok.imagerightnewtab.filename}
              alt={blok.imagerightnewtab.alt}
            />
        </Link>
        </div>
      )}
      <p className="">{blok.textright}</p>
    </div>
  </div>
  </div>
);

export default ServiceImgText;
